import TriggerBroadcasts from '@/views/Admin/TriggerBroadcasts/TriggerBroadcasts.vue';
import { Route } from '../route.model';

const adminTriggerBroadcasts = new Route(
  '/admin/trigger-broadcasts',
  'admin_trigger_broadcasts',
  TriggerBroadcasts,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Trigger Broadcasts',
      icon: ''
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminTriggerBroadcasts };
export default adminTriggerBroadcasts;
